// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c655d3f7","453":"8c3e1671","732":"16246163","977":"6d4b6c7a"}[chunkId] + ".chunk.js";
};